import Layout from '../../components/feature/Layout';
import SistemasGestion from '../home/components/SistemasGestion';
import SEO from '../../components/feature/SEO';

const sistemasJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  name: 'Sistemas de Gestión HSE ISO 45001 ISO 14001',
  provider: {
    '@type': 'Organization',
    name: 'SafeLine Solutions',
    url: `${import.meta.env.VITE_SITE_URL ?? ''}`,
  },
  url: `${import.meta.env.VITE_SITE_URL ?? ''}/sistemas-gestion`,
  description: 'Implementamos sistemas de gestión HSE bajo normas ISO 45001, ISO 14001 e ISO 9001. Acompañamos tu empresa desde el diagnóstico inicial hasta la certificación.',
  areaServed: {
    '@type': 'Place',
    name: 'Latinoamérica',
  },
  serviceType: 'Implementación de Sistemas de Gestión ISO',
  hasOfferCatalog: {
    '@type': 'OfferCatalog',
    name: 'Normas ISO',
    itemListElement: [
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'ISO 45001 - Seguridad y Salud en el Trabajo' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'ISO 14001 - Gestión Ambiental' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'ISO 9001 - Gestión de Calidad' } },
    ],
  },
  breadcrumb: {
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Inicio', item: `${import.meta.env.VITE_SITE_URL ?? ''}/` },
      { '@type': 'ListItem', position: 2, name: 'Servicios', item: `${import.meta.env.VITE_SITE_URL ?? ''}/servicios` },
      { '@type': 'ListItem', position: 3, name: 'Sistemas de Gestión', item: `${import.meta.env.VITE_SITE_URL ?? ''}/sistemas-gestion` },
    ],
  },
};

export default function SistemasGestionPage() {
  return (
    <Layout>
      <SEO
        title="Sistemas de Gestión HSE | ISO 45001 ISO 14001 | SafeLine Solutions"
        description="Implementamos sistemas de gestión HSE bajo normas ISO 45001, ISO 14001 e ISO 9001. Acompañamos tu empresa desde el diagnóstico inicial hasta la certificación en Latinoamérica."
        keywords="sistema gestión HSE, ISO 45001, ISO 14001, ISO 9001, certificación seguridad, gestión ambiental"
        canonical="/sistemas-gestion"
        jsonLd={sistemasJsonLd}
      />
      <div className="pt-20">
        <SistemasGestion />
      </div>
    </Layout>
  );
}
